import { AdvancedSearchPage } from "./AdvancedSearchPage";
export default AdvancedSearchPage;
